import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../../../services/enumeration.service';

@Component({
  selector: 'app-modal-new-settings-autotext',
  templateUrl: './modal-new-settings-autotext.component.html',
  styles: [
  ]
})
export class ModalNewSettingsAutotextComponent extends ExcTranslation implements OnInit {

  @Input() data: any;

  MCEinit: any = {
    placeholder: '',
    formats: {
      bold: [{inline: 'span', styles: {fontWeight: 'bold'}}],
      italic: [{inline: 'span', styles: {fontStyle: 'italic'}}]
    },
    base_url: './tinymce',
    suffix: '.min',
    inline: false,
    height: '100%',
    resize: false,
    menubar: false,
    statusbar: false,

    plugins: ['table', 'paste'],

    valid_styles: {
      '*': 'font-weight,font-style,text-decoration,text-align,color,background-color'
    },

    // beim Paste alle font-family/size hart entfernen
    paste_preprocess: (plugin: any, args: any) => {
      // args.content ist ein HTML-String
      args.content = args.content
        .replace(/font-family\s*:\s*[^;"']+;?/gi, '')
        .replace(/font-size\s*:\s*[^;"']+;?/gi, '')
        .replace(/<font[^>]*>/gi, '')
        .replace(/<\/font>/gi, '');
    },
    content_style:
      '@import url(\'https://fonts.googleapis.com/css?family=Calibri\'); body { font-family: Calibri; font-size: 11pt; }',

    toolbar:
      'table | bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor emoticons',
    table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
    contextmenu: 'bold italic underline strikethrough| \
      alignleft aligncenter alignright alignjustify | \
      forecolor backcolor | table | EXAKTFieldInsert EXAKTTextblockInsert',
    setup: (editor: any) => {
      editor.ui.registry.addNestedMenuItem('EXAKTFieldInsert', {
        text: 'Feld einfügen',
        getSubmenuItems: () => {
          const rtVal: any[] = [];
          for (const dataPlaceholderElement of this.data.dataPlaceholder) {
            rtVal.push({
              type: 'menuitem',
              text:
                dataPlaceholderElement.caption.startsWith('vorg') || dataPlaceholderElement.caption.startsWith('au') ?
                  this.enumSvc.getFieldCaption(
                    dataPlaceholderElement.caption.startsWith('vorg') ? 'Vorgang' : dataPlaceholderElement.caption.startsWith('aue') ? 'AuftragE_EIS' : 'Auftrag',
                    dataPlaceholderElement.caption) : dataPlaceholderElement.caption,
              onAction: () => {
                editor.insertContent(dataPlaceholderElement.placeholder);
              }
            });
          }

          return rtVal;
        }
      });
    }
  };
  dataModel = {
    mode: '',
    tbName: '',
    tbTextShort: '',
    tbText: '',
    tb_enmIdent_Typ: undefined as unknown as number,
    tb_oeID: undefined as unknown as number,
  };
  editor: any;

  constructor(
    private popUpService: ExgModalService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.editor = this.data.editor;
    this.dataModel.mode = this.data.editor.mode;
  }

  getIndexOf(oeID: any): number {
    return this.editor.oeList.findIndex((oe: any) => oe.oeID === oeID);
  }

  selectionChange($event: number): void {
    this.dataModel.tb_oeID = this.editor.oeList.find((oe: any, index: number) => index === $event)?.oeID;
  }

  close(): void {
    this.popUpService.close();
  }

  create(): void {
    this.popUpService.action(this.dataModel);
  }
}
